import { INDEXED_DB_NAME, OBJECT_STORES } from '../../constants/storage-keys';
import { fetchActiveDoctorsList, fetchInActiveDoctors, fetchDoctorSettings } from '../../services/apicalls/doctor';
import { TDoctor, TDoctorSetting } from '../../types/doctor';
const DB_VERSION = 11;
export const initIDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(INDEXED_DB_NAME, DB_VERSION);
        request.onerror = (event) => {
            console.log("indexed db error ", event);
            reject(event);
        }
        request.onupgradeneeded = (event) => {
            const DB = request.result;
            DB.createObjectStore(OBJECT_STORES.stores, { keyPath: 'key' });
            DB.createObjectStore(OBJECT_STORES.store_meta_data, { keyPath: 'store_name' });
            DB.createObjectStore(OBJECT_STORES.active_doctors, { keyPath: 'id' });
            DB.createObjectStore(OBJECT_STORES.in_active_doctors, { keyPath: 'id' });
            DB.createObjectStore(OBJECT_STORES.un_approve_doctors, { keyPath: 'id' });
            DB.createObjectStore(OBJECT_STORES.doctor_settings, { keyPath: 'doctor_id' });
            DB.createObjectStore(OBJECT_STORES.todays_patients, { keyPath: 'doctor_id' });
            DB.createObjectStore(OBJECT_STORES.todays_bookings, { keyPath: 'doctor_id' });
        }
    })
}
export const clearIDB = async () => {
    await deleteData(OBJECT_STORES.stores);
    await deleteData(OBJECT_STORES.store_meta_data);
    await deleteData(OBJECT_STORES.active_doctors);
    await deleteData(OBJECT_STORES.in_active_doctors);
    await deleteData(OBJECT_STORES.un_approve_doctors);
    await deleteData(OBJECT_STORES.doctor_settings);
    await deleteData(OBJECT_STORES.todays_patients);
    await deleteData(OBJECT_STORES.todays_bookings);
}
export const storeData = async (store_name: string, data: any[], action_type: string = 'add') => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(INDEXED_DB_NAME, DB_VERSION);
        request.onsuccess = () => {
            const DB = request.result;
            if (data.length > 0) {
                const objectStore = DB.transaction(store_name, 'readwrite').objectStore(store_name);
                if (data.length > 1) {
                    for (let row of data) {
                        if (action_type === 'update') {
                            objectStore.put(row);
                        } else {
                            objectStore.add(row)
                        }
                    }
                } else {
                    if (action_type === 'update') {
                        objectStore.put(data[0]);
                    } else {
                        objectStore.add(data[0])
                    }
                }
            }
            const metaDataObjectStore = DB.transaction(OBJECT_STORES.store_meta_data, 'readwrite').objectStore(OBJECT_STORES.store_meta_data);
            const deleteRequest = metaDataObjectStore.delete(store_name);
            deleteRequest.onsuccess = () => {
                metaDataObjectStore.add({ store_name: store_name, last_update_time: new Date() });
                DB.close();
            }
            resolve(null);
        }
        request.onerror = (event) => {
            console.log("store data error", event)
        }
    })
}
type Tfilter = {
    [key: string]: string | number
}
export const getData = <T>(store_name: string, key: string | number = '', filter: Tfilter | null = null): Promise<T> => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(INDEXED_DB_NAME, DB_VERSION);
        request.onsuccess = () => {
            const DB = request.result;
            const objectstoreTransaction = DB.transaction(store_name, 'readwrite').objectStore(store_name);
            if (!key && filter === null) {
                const objectStoreRequest = objectstoreTransaction.getAll();
                objectStoreRequest.onsuccess = () => {
                    DB.close();
                    resolve(<T>objectStoreRequest.result)
                }
            } else if (key && filter === null) {
                const objectStoreRequest = objectstoreTransaction.get(key);
                objectStoreRequest.onsuccess = () => {
                    DB.close();
                    resolve(objectStoreRequest.result)
                }
            } else if (!key && filter !== null) {
                const objectStoreRequest = objectstoreTransaction.getAll();
                objectStoreRequest.onsuccess = () => {
                    DB.close();
                    resolve(<T>objectStoreRequest.result)
                }
            }
        }
    })
}
export const deleteData = (store_name: string, key?: string | number) => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(INDEXED_DB_NAME, DB_VERSION);
        request.onsuccess = () => {
            const DB = request.result;
            const objectstoreTransaction = DB.transaction(store_name, 'readwrite');
            const objectstore = objectstoreTransaction.objectStore(store_name);
            if (key) {
                objectstore.delete(key);
            } else {
                objectstore.clear();
            }
            objectstoreTransaction.oncomplete = () => {
                resolve(null)
            }
            objectstoreTransaction.onerror = () => {
                reject();
            }
        }
    })
}
export const getActiveDoctors = (): Promise<TDoctor[]> => {
    return new Promise(async (resolve, reject) => {
        try {
            let active_doctors = await getData<TDoctor[]>(OBJECT_STORES.active_doctors);
            let storeMetaData = await getData(OBJECT_STORES.store_meta_data, OBJECT_STORES.active_doctors);
            if (active_doctors.length) {
                resolve(active_doctors);
                return;
            }
            if (storeMetaData && active_doctors.length === 0) {
                resolve([]);
                return;
            }
            fetchActiveDoctorsList().then(({ data }) => {
                storeData(OBJECT_STORES.active_doctors, data);
                resolve(data);
            })
        } catch (err) {
            fetchActiveDoctorsList().then(({ data }) => {
                storeData(OBJECT_STORES.active_doctors, data);
                resolve(data);
            })
        }
    })
}
export const getDoctorDetail = (doctor_id: number):Promise<TDoctor> => {
    return new Promise(async (resolve, reject) => {
        let active_doctor = await getData<TDoctor>(OBJECT_STORES.active_doctors, doctor_id);
        if (active_doctor) {
            resolve(active_doctor)
        } else {
            reject("No data found from cache")
        }
    })
}
export const getInActiveDoctors = (): Promise<TDoctor[]> => {
    return new Promise(async (resolve, reject) => {
        try {
            let inactive_doctors = await getData<TDoctor[]>(OBJECT_STORES.in_active_doctors);
            let storeMetaData = await getData(OBJECT_STORES.store_meta_data, OBJECT_STORES.in_active_doctors);
            if (inactive_doctors.length) {
                resolve(inactive_doctors);
                return;
            }
            if (storeMetaData && inactive_doctors.length === 0) {
                resolve([]);
                return;
            }
            fetchInActiveDoctors(0).then(({ data }) => {
                storeData(OBJECT_STORES.in_active_doctors, data);
                resolve(data);
            })
        } catch (err) {
            fetchInActiveDoctors(0).then(({ data }) => {
                resolve(data);
            })
        }
    })
}
export const getUnApprovedDoctors = (): Promise<TDoctor[]> => {
    return new Promise(async (resolve, reject) => {
        try {
            let unapprove_doctors = await getData<TDoctor[]>(OBJECT_STORES.un_approve_doctors);
            let storeMetaData = await getData(OBJECT_STORES.store_meta_data, OBJECT_STORES.un_approve_doctors);
            if (unapprove_doctors.length) {
                resolve(unapprove_doctors);
                return;
            }
            if (storeMetaData && unapprove_doctors.length === 0) {
                resolve([]);
                return;
            }
            fetchInActiveDoctors(-5).then(({ data }) => {
                storeData(OBJECT_STORES.un_approve_doctors, data);
                resolve(data);
            })
        } catch (err) {
            fetchInActiveDoctors(-5).then(({ data }) => {
                resolve(data);
            })
        }
    })
}
export const getAllDoctorsSettings = (): Promise<TDoctorSetting[]> => {
    return new Promise(async (resolve, reject) => {
        try {
            let doctorSettings = await getData<TDoctorSetting[]>(OBJECT_STORES.doctor_settings);
            let storeMetaData = await getData(OBJECT_STORES.store_meta_data, OBJECT_STORES.doctor_settings);
            if (doctorSettings.length) {
                resolve(doctorSettings);
                return;
            }
            if (storeMetaData && doctorSettings.length === 0) {
                resolve([]);
                return;
            }
            fetchDoctorSettings().then(({ data }) => {
                storeData(OBJECT_STORES.doctor_settings, data);
                resolve(data);
            })
        } catch (err) {
            fetchDoctorSettings().then(({ data }) => {
                resolve(data);
            })
        }

    })
}

